/* eslint-disable camelcase */
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

// Components
import { Normal } from '../../components/Button';
import { TextField, useForm } from '../../components/FormInputs';
import { getQueryParams } from '../../helperFunctions';

// Styles
import { Body, Footer } from '../../styles/modal';
import { Text } from '../../styles/common';

const INITIAL_STATE = {
  passcode: {
    value: undefined,
    required: true,
  },
};

const DownloadWithPasscode = props => {
  const { location, verifySharedAsset, assetDetails, toggleModal } = props;

  const [isSubmitting, setSubmitting] = useState(false);

  const shareToken =
    assetDetails?.share_token || getQueryParams(location).get('shared');

  const { formValues, onChange, onSubmit, updateValues } = useForm(
    INITIAL_STATE,
    async () => {
      setSubmitting(true);
      const assetResponse = await verifySharedAsset(
        {
          ingest_db_id: assetDetails?.ingest_db_id,
          shared: shareToken ?? null,
          download_type: 'original',
          passcode: formValues?.passcode?.value?.trim(),
        },
        'post'
      );
      const {
        data: { response, data, errormessage },
      } = assetResponse;
      if (response && data) {
        setSubmitting(false);
        window.open(data.download_link, '_blank');
        toggleModal(null, false, null);
      } else {
        setSubmitting(false);
        updateValues({
          ...formValues,
          passcode: {
            ...formValues?.passcode,
            error: errormessage,
          },
        });
      }
    }
  );

  return (
    <>
      <Body>
        <Text paddingLeft='0' paddingRight='0'>
          Enter the Passcode to download the asset
        </Text>
        <TextField
          id='passcode'
          label='Enter Passcode'
          value={formValues.passcode.value}
          onChange={onChange}
          error={!!formValues.passcode.error}
          helperText={formValues.passcode.error}
        />
      </Body>

      <Footer>
        <Normal
          onClick={onSubmit}
          style={{ width: 'auto' }}
          disabled={isSubmitting}
        >
          Download
        </Normal>
      </Footer>
    </>
  );
};

DownloadWithPasscode.propTypes = {
  assetDetails: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
  verifySharedAsset: PropTypes.func,
  toggleModal: PropTypes.func,
};

export default DownloadWithPasscode;
